import React from 'react';
import './FormItemDivider.css';

const FormItemDivider: React.FC = () => (<div className="fos-form-item-divider" />);

export default FormItemDivider;
